import React from 'react'
import HomePageContainer from '../../containers/customer_portal/dashboard'

const HomePage = () => {
  return <HomePageContainer />
}

export default HomePage;
